import { render, staticRenderFns } from "./CardNewTemplate.vue?vue&type=template&id=58490f48&"
import script from "./CardNewTemplate.vue?vue&type=script&lang=js&"
export * from "./CardNewTemplate.vue?vue&type=script&lang=js&"
import style0 from "./CardNewTemplate.vue?vue&type=style&index=0&id=58490f48&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports